module.exports = __webpack_public_path__ + "static/media/vision.a0164a65.jpg";